import React from "react";
import { Text, TouchableOpacity } from "react-native";

import { Modal } from "components";
import { Picker as ThemeBPicker } from "screens/main/themeB/components/options-list";
import { Picker as ThemeAPicker } from "screens/main/themeA/components/options-list";

import { styles } from "./styles";

export const Picker = ({
  options,
  textKey,
  onPress,
  visible,
  dismiss,
  selectedOption = {},
  isThemeB = false,
}) => {
  return (
    <Modal visible={visible}>
      {!isThemeB && (
        <ThemeAPicker
          options={options}
          textKey={textKey}
          onPress={onPress}
          selectedOption={selectedOption}
        />
      )}
      {isThemeB && (
        <ThemeBPicker
          options={options}
          textKey={textKey}
          onPress={onPress}
          selectedOption={selectedOption}
        />
      )}
      <TouchableOpacity style={styles.closeButton} onPress={dismiss}>
        <Text style={styles.closeButtonText}>CLOSE</Text>
      </TouchableOpacity>
    </Modal>
  );
};
